import React from 'react';
import searchIcon from 'assets/images/search.svg';
import DropdownBlue from '../../../../../components/Atoms/Dropdown/DropdownBlue/DropdownBlue';
import TabsFilters from './TabsFilters';

interface LoansHeaderProps {
  loanStateFilter: string;
  onLoanStateChange: (item: any) => void;
  searchTerm: string | undefined;
  onSearch: (event: React.ChangeEvent<HTMLInputElement>) => void;
  tabTotals: { all: number; error: number };
  filter: string;
  onFilterChange: (filter: string) => void;
}

const LoansHeader = ({
  loanStateFilter,
  onLoanStateChange,
  searchTerm,
  onSearch,
  tabTotals,
  filter,
  onFilterChange,
}: LoansHeaderProps) => {
  return (
    <>
      <div className='view-loans-header'>
        <h1 className='title'>
          <DropdownBlue
            items={[
              { key: 'Active', label: 'Active' },
              { key: 'Closed', label: 'Closed' },
              { key: 'Waiting', label: 'Waiting' },
              { key: 'Dead', label: 'Archived' },
              { key: 'All', label: 'All' }
            ]}
            onClickSelect={(item: any) => onLoanStateChange(item)}
            label={loanStateFilter === 'Dead' ? 'Archived' : loanStateFilter}
          />
          <span>loans</span>
        </h1>
        <div className='search-box'>
          <img src={searchIcon} alt="search" />
          <input
            type="text"
            placeholder="Search by entity or loan address"
            value={searchTerm}
            onChange={onSearch}
          />
        </div>
      </div>

      <div className='view-loans-filters'>
        <TabsFilters
          tabTotals={tabTotals}
          filter={filter}
          handlerChange={onFilterChange}
        />
      </div>
    </>
  );
};

export default LoansHeader;
